import React from 'react';
import { IconSaxIcon } from '@/components/design-system/atoms/icon';

interface NavigationTabsProps {
  virtualTourAvailable: boolean;
  selectedTabIndex: number;
  slidesLength: number;
  onTabSelect: (index: number) => void;
  isMobile: boolean;
}

const NavigationTabs: React.FC<NavigationTabsProps> = ({
  virtualTourAvailable,
  selectedTabIndex,
  slidesLength,
  onTabSelect,
  isMobile,
}) => {
  return (
    <div
      style={{
        width: '168px',
        left: '50%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        opacity: 1,
        height: '48px',
        backgroundColor: '#000000B2',
        bottom: isMobile ? '42rem' : '48px',
      }}
      className="absolute z-10 -translate-x-1/2 rounded-full px-4 py-2"
    >
      <div className="flex items-center justify-center gap-4">
        {virtualTourAvailable && (
          <button
            type="button"
            className="relative flex items-center justify-center"
            onClick={() => onTabSelect(0)}
          >
            <IconSaxIcon name="vr" size={24} strokeColor="none" />
            {selectedTabIndex === 0 && (
              <div className="absolute -bottom-1 h-1 w-6 rounded-full bg-[#FECE1F]"></div>
            )}
          </button>
        )}

        <button
          type="button"
          className="relative flex items-center justify-center"
          onClick={() => onTabSelect(virtualTourAvailable ? 1 : 0)}
        >
          <IconSaxIcon name="gallery" size={24} strokeColor="#FFFFFF" strokeWidth={0.5} />
          {selectedTabIndex >= (virtualTourAvailable ? 1 : 0) &&
            selectedTabIndex < slidesLength - 1 && (
              <div className="absolute -bottom-1 h-1 w-6 rounded-full bg-[#FECE1F]"></div>
            )}
        </button>

        <button
          type="button"
          className="relative flex items-center justify-center"
          onClick={() => onTabSelect(slidesLength - 1)}
        >
          <IconSaxIcon name="map" size={24} strokeColor="#FFFFFF" />
          {selectedTabIndex === slidesLength - 1 && (
            <div className="absolute -bottom-1 h-1 w-6 rounded-full bg-[#FECE1F]"></div>
          )}
        </button>
      </div>
    </div>
  );
};

export default NavigationTabs;
